import Color from 'color'

/**
 * Blends a colour over a background at 70%, returning the solid equivalent of
 * that colour drawn at 0.7 opacity. Lets the environment banner and the safe
 * area top strip share the exact same muted colour without CSS opacity, which
 * would otherwise blend differently against their two different backdrops.
 */
function mutedBannerColor(color: string, background: string): string {
  return new Color(color).mix(new Color(background), 0.3).hex()
}

// this utility is used to welcome users in the console
function getRandomRGBNumber() {
  return Math.floor(Math.random() * 256)
}

function getRandomColor() {
  const r = getRandomRGBNumber()
  const g = getRandomRGBNumber()
  const b = getRandomRGBNumber()

  return [`rgb(${r}, ${g}, ${b})`, `rgb(${255 - r}, ${255 - g}, ${255 - b})`]
}

export { getRandomColor, mutedBannerColor }
